import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { QueryKey } from '../../../query-client';
import { IPagination } from '../../IPagination';
import {
    confirmNominationReadinessTrack,
    createNominationReadinessTrack,
    deleteNominationReadinessTrack,
    fetchNominationReadinessTracks,
    validateNominationReadinessTrack,
} from './index';
import { ICreateNominationReadinessTrack, IFetchNominationReadinessTrackPageQuery, INominationReadinessTrack } from './interface';

export const useNominationReadinessValidateMutation = () => {
    return useMutation<null, Error, string[]>({
        mutationFn: nominationIds => validateNominationReadinessTrack(nominationIds),
    });
};

export const useNominationReadinessTrackCreateMutation = () => {
    return useMutation<void, Error, ICreateNominationReadinessTrack>({
        mutationFn: data => createNominationReadinessTrack(data),
    });
};

export const useNominationReadinessTrackListQuery = (query: IFetchNominationReadinessTrackPageQuery, options = {}) => {
    return useQuery<IPagination<INominationReadinessTrack>, Error>({
        queryKey: [QueryKey.NOMINATION_READINESS_TRACKS, query],
        queryFn: () => fetchNominationReadinessTracks(query),
        ...options,
    });
};

export const useNominationReadinessTrackDeleteMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<void, Error, string>(deleteNominationReadinessTrack, {
        onSuccess: async () => {
            await queryClient.invalidateQueries([QueryKey.NOMINATION_READINESS_TRACKS]);
        },
    });
};

export const useNominationReadinessTrackConfirmMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<void, Error, string>(confirmNominationReadinessTrack, {
        onSuccess: async () => {
            await queryClient.invalidateQueries([QueryKey.NOMINATION_READINESS_TRACKS]);
        },
    });
};
